import { gql, useQuery } from '@apollo/client';
import { HOUSE_STYLE_V1, HouseStyle } from 'shared/lib/widgetCode/houseStyle';

const CURRENT_HOUSE_STYLE = gql`
  query CurrentHouseStyle {
    houseStyle {
      version
      fontEn
      fontZh
      colors { token value use }
      radiusButton
      radiusCard
    }
  }
`;

/** The current house style; v1 until it has loaded. */
export default function useHouseStyle(): HouseStyle {
  const { data } = useQuery<{ houseStyle: HouseStyle }>(CURRENT_HOUSE_STYLE, { fetchPolicy: 'cache-and-network' });
  return (data && data.houseStyle) || HOUSE_STYLE_V1;
}
